<template>
  <v-form class="form-Edit-Profile my-10">
    <v-container>
      <v-text-field
        v-model="currentPassword"
        label="Current Password"
        placeholder="Current Password"
        required
      ></v-text-field>
      <v-text-field
        v-model="newPassword"
        label="New Password"
        placeholder="New Password"
        required
      ></v-text-field>
      <v-text-field
        v-model="repeatNewPassword"
        label="Repeat New Password"
        placeholder="Repeat New Password"
        required
      ></v-text-field>
      <v-row class="d-flex justify-center my-8">
        <v-btn
          class="white--text text-btn-EditProfile"
          depressed
          color="#238EF6"
          style="text-transform: capitalize"
        >
          change
        </v-btn>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  data:()=>({
    currentPassword:"",
    newPassword:"",
    repeatNewPassword:""
  })
};
</script>

<style>
.text-btn-EditProfile {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
</style>